import React, { useEffect, useState } from "react";
import ErcModal from "../../modules/shared/components/ErcModal";
import Rating from "../../components/Rating";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { CREATE_QNA_RESET } from "../../constants/qnaConstants";
import {
  convertToUrl,
  removeDuplicatesByProperty,
  setScrollHeight,
} from "../../libraries/ercLibrary";
import ImagePath from "./ImagePath";
import VideoPlayer from "./VideoPlayer";
import OrderCartWithVariants from "./OrderCartWithVariants";
import FrequentlyAskedQuestions from "../../components/FrequentQuestions/FrequentlyAskedQuestions";

export default function SectContent(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  // PROPS ARE COMING FROM ProductLandings
  const {
    sect,
    reviewsList,
    product,
    loadingCampaign,
    errorCampaign,
    productCampaign,
    orderNowCards,
    camp,
    AdvantagesBoard,
    cartSkuItems,
    clearCartSkuItems,
    handleBuyButton,
    ShippingMessage,
    userForm,
    loadingSkuData,
    errorSkuData,
    width,
    skuData,
    isPending,
    qty,
    price,
    variants,
    setChoosenVariants,
    choosenVariants,
    setVariantAlert,
    variantAlert,
    setNoSkuAlert,
    qtyAlert,
    setQty,
    multiSku,
    setQtyAlert,
    disableButton,
    addToCartHandler,
    noSkuAlert,
    pendingPush,
    isDiscountValid,
    remainingTime,
  } = props;

  // Sort review list to display reviews with images prior to reviews without images
  const [sortedReviewList, setSortedReviewList] = useState([]);
  useEffect(() => {
    if (reviewsList?.length > 0) {
      const reviewsWithImages = reviewsList.filter(
        (review) => review.images[0]
      );
      /* const reviewsWithoutImages = reviewsList.filter(
        (review) => !review.images[0]
      );*/

      setSortedReviewList(
        removeDuplicatesByProperty(
          [...reviewsWithImages, ...reviewsList],
          "_id"
        )
      );
    }
  }, [reviewsList]);

  return (
    <>
      {sect.content.map((cont, index) => {
        return (
          <div key={index} className={sect.contentType}>
            {sect.contentType === "contentTitleMain" ? (
              <h3>{cont}</h3>
            ) : sect.contentType === "contentList" ? (
              <ul>
                <li>
                  <i className="fas fa-long-arrow-alt-right fs2 beddo-color marh"></i>
                  {cont}
                </li>
              </ul>
            ) : sect.contentType === "contentParagraphs" ? (
              <div className="col">
                <p>{cont}</p>
              </div>
            ) : sect.contentType === "contentParagraphsWithTitle" ? (
              <div className="col">
                <p>
                  <>
                    <span className="bold-font fs125">
                      {cont.substring(0, cont.indexOf(","))}
                    </span>
                    {cont.slice(cont.indexOf(",") + 1)}
                  </>
                </p>
              </div>
            ) : sect.contentType === "contentListWithTitle" ? (
              <ul className="col">
                <li>
                  <>
                    <i className="fas fa-long-arrow-alt-right fs2 beddo-color marh txtmid"></i>
                    <span className="bold-font fs125">
                      {cont.substring(0, cont.indexOf(","))}
                    </span>
                    {cont.slice(cont.indexOf(",") + 1)}
                  </>
                </li>
              </ul>
            ) : sect.contentType === "contentReview" ? (
              <div className="w100p col-left">
                <>
                  {sortedReviewList &&
                    sortedReviewList.length > 0 &&
                    sortedReviewList.map((review, index) => {
                      return (
                        <>
                          <div
                            key={index + 100}
                            className="contentReviewChild slightlyyellowbck"
                          >
                            <Rating value={review.rating} />
                            <p className="fs1">{review.comment}</p>
                            {review.images &&
                              review.images.length > 0 &&
                              review.images.map((image) => {
                                return (
                                  image && (
                                    <img
                                      key={image}
                                      className="w25p mar1"
                                      src={image}
                                      alt={"beddo™"}
                                    />
                                  )
                                );
                              })}
                            <div className="row-left">
                              <p className="fs1 marupsideh">
                                {review.firstName + " " + review.lastName}{" "}
                              </p>
                              <p className="fs1 marupsideh">
                                {review.createdAt.substring(0, 10)}
                              </p>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </>
              </div>
            ) : sect.contentType === "contentOrderNowWithVariants" ? (
              <OrderCartWithVariants
                loadingSkuData={loadingSkuData}
                errorSkuData={errorSkuData}
                product={product}
                loadingCampaign={loadingCampaign}
                errorCampaign={errorCampaign}
                productCampaign={productCampaign}
                width={width}
                skuData={skuData}
                clearCartSkuItems={clearCartSkuItems}
                isPending={isPending}
                qty={qty}
                price={price}
                cartSkuItems={cartSkuItems}
                variants={variants}
                setChoosenVariants={setChoosenVariants}
                choosenVariants={choosenVariants}
                setVariantAlert={setVariantAlert}
                variantAlert={variantAlert}
                setNoSkuAlert={setNoSkuAlert}
                qtyAlert={qtyAlert}
                setQty={setQty}
                multiSku={multiSku}
                setQtyAlert={setQtyAlert}
                disableButton={disableButton}
                addToCartHandler={addToCartHandler}
                noSkuAlert={noSkuAlert}
                pendingPush={pendingPush}
                isDiscountValid={isDiscountValid}
                remainingTime={remainingTime}
              />
            ) : sect.contentType === "contentOrderNow" ? (
              <>
                <div className="row-space-around lightbck w100p h10r">
                  <ErcModal
                    modalTitle={() => (
                      <>
                        Nasıl kolayca iade edilir
                        <i className="far fa-question-circle green fs125 marq"></i>
                      </>
                    )}
                    modalTitleFontSize={"1.25rem"}
                    modalTitleLineHeight={"2rem"}
                    modalTitleColor={"#0645ad"}
                    modalTitleUnderline={"0.1rem solid #0645ad"}
                    contentTitle={`İade Başlatmak Çok Kolay`}
                    contentTitleFontSize={"1.35rem"}
                    content={[
                      `* beddo.com müşteri hizmetleri sayfasına gidin.`,
                      `* Sistemde kayıtlı cep telefonu numaranız ile güvenli giriş yapın.`,
                      `* Giriş yaptıktan sonra siparişlerim sayfasına gidin ve "Kolay İade Başlat" butonunu tıklayın.`,
                      `* Yönergeleri izleyerek saniyeler içinde bir ücretsiz kargo kodu oluşturun.`,
                      `* İade paketi oluşturduğunuz kargo kodu ile kargo şubesine teslim edin. `,
                      `* Akıllı beddo™ sistemi, iade paketi takip eder ve depomuza ulaşmasını takip eden 24 saat içinde kartınıza iade eder.`,
                      `* Kapıda ödeme yaptı iseniz iade başlatırken girdiğiniz IBAN numarasına havale/EFT yapılır.`,
                    ]}
                    modalParagBorderBottom={"0.1rem solid #ff9935"}
                    modalParagFontSize={"1.25rem"}
                  />
                  <ErcModal
                    modalTitle={() => (
                      <>
                        Teknik Özellikler
                        <i className="fas fa-info-circle green fs125 marq"></i>
                      </>
                    )}
                    modalTitleFontSize={"1.25rem"}
                    modalTitleLineHeight={"2rem"}
                    modalTitleColor={"#0645ad"}
                    modalTitleUnderline={"0.1rem solid #0645ad"}
                    contentTitle={`${product.name} | Teknik Özellikler`}
                    contentTitleFontSize={"1.35rem"}
                    content={[
                      product.technicInfo.productSize &&
                        `* ${product.technicInfo.productSize}`,
                      product.technicInfo.fabricType &&
                        `* ${product.technicInfo.fabricType}`,
                      product.technicInfo.fabricTouch &&
                        `* ${product.technicInfo.fabricTouch}`,
                      product.technicInfo.fabricProductionMethod &&
                        `* ${product.technicInfo.fabricProductionMethod}`,
                      product.technicInfo.fabricWeight &&
                        `* ${product.technicInfo.fabricWeight}`,
                      product.technicInfo.fillingType &&
                        `* ${product.technicInfo.fillingType}`,
                      product.technicInfo.fillingProductionMethod &&
                        `* ${product.technicInfo.fillingProductionMethod}`,
                      product.technicInfo.ingridients &&
                        `* ${product.technicInfo.ingridients}`,
                      product.technicInfo.material &&
                        `* ${product.technicInfo.material}`,
                    ]}
                    modalParagBorderBottom={"0.1rem solid #ff9935"}
                    modalParagFontSize={"1.25rem"}
                  />
                  <ErcModal
                    modalTitle={() => (
                      <>
                        Paket İçeriği
                        <i className="fas fa-info-circle green fs125 marq"></i>
                      </>
                    )}
                    modalTitleFontSize={"1.25rem"}
                    modalTitleLineHeight={"2rem"}
                    modalTitleColor={"#0645ad"}
                    modalTitleUnderline={"0.1rem solid #0645ad"}
                    contentTitle={`${product.name} | Paket İçeriği`}
                    contentTitleFontSize={"1.35rem"}
                    content={[product.boxContent && `* ${product.boxContent}`]}
                    modalParagBorderBottom={"0.1rem solid #ff9935"}
                    modalParagFontSize={"1.25rem"}
                  />
                  <ErcModal
                    modalTitle={() => (
                      <>
                        Ürün Soruları
                        <i className="fas fa-info-circle green fs125 marq"></i>
                      </>
                    )}
                    modalTitleFontSize={"1.25rem"}
                    modalTitleLineHeight={"2rem"}
                    modalTitleColor={"#0645ad"}
                    modalTitleUnderline={"0.1rem solid #0645ad"}
                    contentTitle={`${product.name} | Ürün Soruları`}
                    contentTitleFontSize={"1.35rem"}
                    /* IF PRODUCT IS ORTHOPEDIC CUSHION REMOVE FIRST WO QUESTION */
                    content={
                      product.productQuestions &&
                      product._id === "6142753f1e293f5d089dbd14"
                        ? product.productQuestions.slice(4)
                        : product.productQuestions
                    }
                    modalParagBorderBottom={"0.1rem solid #ff9935"}
                    modalParagFontSize={"1.25rem"}
                  />
                </div>
                <div className="row-center w100p marupside1 padupsideh-5 greenbcklight">
                  <h1 className="fs15 lh2 beddo-border-bottom">
                    {product.freeProductId &&
                    product.buyOneGetOneFree &&
                    !loadingCampaign &&
                    !errorCampaign
                      ? `Bir beddo™ ${
                          product.name.split("|")[1]
                        } Alan Herkese Bir ${
                          productCampaign.name.split("|")[1]
                        } Bedava`
                      : product.name}
                  </h1>
                </div>
                <ul className="contentOrderNowCardHolderBox ">
                  {orderNowCards.map((card, index) => {
                    return (
                      <li key={index + 1000} className="contentOrderNowCard">
                        <div
                          className={
                            index === 0
                              ? "divOrderNowCard beddo-border-cart"
                              : index === 1
                              ? "divOrderNowCard linkblue-border"
                              : index === 2 && "divOrderNowCard green-border"
                          }
                        >
                          <div>
                            {card.qty === 1 ? (
                              <p>
                                {card.qty}{" "}
                                {product.productUnit
                                  ? product.productUnit
                                  : "Adet"}{" "}
                                {card.price} TL
                              </p>
                            ) : (
                              <p>
                                {card.qty}{" "}
                                {product.productUnit
                                  ? product.productUnit
                                  : "Adet"}{" "}
                                <strike className="red-col">
                                  {Math.ceil(card.priceForOne * card.qty)}
                                </strike>{" "}
                                Yerine {card.price} TL
                              </p>
                            )}
                          </div>
                          <div className="beddo-border-bottom">
                            {card.imageRepeats.map((reapeat, index) => (
                              <img
                                key={reapeat + index + 10000}
                                className="contentOrderNowImages"
                                src={
                                  sect.skuChoice &&
                                  orderNowCards[0].skus.find(
                                    (sku) => sku.sku === sect.skuChoice
                                  ).skuImages[
                                    camp.orderNowCardImageIndex
                                      ? camp.orderNowCardImageIndex
                                      : 0
                                  ]
                                }
                                alt={product.name}
                              />
                            ))}
                          </div>
                          {product.freeProductId &&
                            product.buyOneGetOneFree && (
                              <p className="fs1">
                                Siparişiniz İle Birlikte Bedava
                              </p>
                            )}
                          {product.freeProductId &&
                            product.buyOneGetOneFree &&
                            orderNowCards[0].freeSkus && (
                              <div className="beddo-border-bottom">
                                {card.imageRepeats.map((reapeat, index) => (
                                  <img
                                    key={reapeat + index + 100000}
                                    className="contentOrderNowImages"
                                    src={
                                      sect.skuChoice &&
                                      orderNowCards[0].freeProductSkus
                                        .length === 1
                                        ? orderNowCards[0].skus.find(
                                            (sku) =>
                                              sku.sku.substring(
                                                sku.sku.length - 3,
                                                sku.sku.length
                                              ) ===
                                              orderNowCards[0].freeProductSkus[0].substring(
                                                orderNowCards[0]
                                                  .freeProductSkus[0].length -
                                                  3,
                                                orderNowCards[0]
                                                  .freeProductSkus[0].length
                                              )
                                          ).skuImages[
                                            camp.orderNowCardImageIndex
                                              ? camp.orderNowCardImageIndex
                                              : 0
                                          ]
                                        : orderNowCards[0].freeSkus.find(
                                            (sku) =>
                                              sect.skuChoice.substring(
                                                sect.skuChoice.length - 3,
                                                sect.skuChoice.length
                                              ) ===
                                              sku.sku.substring(
                                                sku.sku.length - 3,
                                                sku.sku.length
                                              )
                                          ).skuImages[
                                            camp.orderNowCardImageIndex
                                              ? camp.orderNowCardImageIndex
                                              : 0
                                          ]
                                    }
                                    alt={product.name}
                                  />
                                ))}
                              </div>
                            )}
                          <AdvantagesBoard
                            product={product}
                            productCampaign={productCampaign}
                            cartSkuItems={cartSkuItems}
                          />
                          <button
                            type="button"
                            className="contentOrderNowButton"
                            onClick={() => {
                              setScrollHeight(location.pathname.slice(1, 5));
                              clearCartSkuItems();
                              setTimeout(() => {
                                handleBuyButton(
                                  card.qty,
                                  card.skus.find(
                                    (sku) => sku.sku === sect.skuChoice
                                  ),
                                  camp.appeal,
                                  product.freeProductId,
                                  product.freeProductSkus,
                                  product.buyOneGetOneFree
                                );
                              }, 1000);
                            }}
                          >
                            Şimdi Sipariş Ver
                          </button>
                          <div className="beddo-border">
                            <ShippingMessage product={product} />
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </>
            ) : sect.contentType === "contentButtonLink" ? (
              <div className="col">
                <p className="buttonSectionContent">{sect.content}</p>
                <a className="contentButtonLink" href={sect.buttonLink}>
                  <button type="button">{sect.buttonContent}</button>
                </a>
              </div>
            ) : sect.contentType === "contentQna" ? (
              <ErcModal
                modalTitleDivWidth={"85%"}
                modalTitle={() => (
                  <div className="row-qna w100p">
                    <button
                      type="button"
                      className="primary w50p"
                      onClick={() => {
                        dispatch({
                          type: CREATE_QNA_RESET,
                        });
                      }}
                    >
                      Soru Sor
                    </button>
                    <Link
                      className="w50p"
                      to={`/sorucevap/${convertToUrl(product.name)}/${
                        product._id
                      }?product=${product.name}?image=${
                        product.defaultImages[0]
                      }?appeal=${camp.appeal}`}
                      onClick={() =>
                        setScrollHeight(location.pathname.slice(1, 5))
                      }
                    >
                      <button
                        type="button"
                        className="primary-transparent w100p"
                      >
                        Soru Cevap Oku
                      </button>
                    </Link>
                  </div>
                )}
                modalTitleFontSize={"1rem"}
                modalTitleLineHeight={"2rem"}
                contentTitleFontSize={"1.35rem"}
                contentTitle={"Soru Formu"}
                content={userForm}
                modalParagFontSize={"1.25rem"}
                disableModalTitle={true}
              />
            ) : sect.contentType === "contentFrequentlyAskedQuestions" ? (
              <FrequentlyAskedQuestions
                product={product}
                questions={product?.productQuestions}
              />
            ) : (
              cont
            )}
          </div>
        );
      })}
      <ImagePath sect={sect} />
      <VideoPlayer sect={sect} />
    </>
  );
}
